import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import Eye from "../../assets/images/eye.svg";
import Lock from "../../assets/images/lock.svg";
import Unlock from "../../assets/images/unlock.svg";
import Info from "../../assets/images/info.svg";
import Infos from "../../assets/images/info-b.svg";
import add from "../../assets/images/add.svg";
import sdot from "../../assets/images/sdot.svg";
import star from "../../assets/images/star.svg";
import dot from "../../assets/images/dot.svg";
import edit from "../../assets/images/edit.svg";
import editA from "../../assets/images/editAct.svg";
import trash from "../../assets/images/trash.svg";
import video from "../../assets/images/video.svg";
import Rich from "../../assets/images/rich.svg";
import Videoplay from "../../assets/images/v-play.svg";
import Videoimg from "../../assets/images/video-img.svg";
import Upload from "../../assets/images/upload.png";
import Helps from "../../assets/images/help.svg";
import fileplus from "../../assets/images/file-plus.svg";
import close from "../../assets/images/Close.svg";
import imp from "../../assets/images/import.svg";
import save from "../../assets/images/save-light.svg";
import saves from "../../assets/images/save.svg";
import searchsmall from "../../assets/images/Search.svg";
import addsP from "../../assets/images/plus_circle.svg";
import Modal from "react-modal";
import Form from "react-bootstrap/Form";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import Spinner from "../../components/Spinner";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useLocation, useNavigate } from "react-router-dom";
import { replace } from "formik";
import { BorderColor, Help } from "@material-ui/icons";
import { colors } from "@material-ui/core";
import Alert from "../../assets/images/alert-circle.svg";
import closex from "../../assets/images/X.svg";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import DocumentUpload from "./DocumentUpload";
import "../../assets/css/responsive.css";

import filetext from "../../assets/images/file-text 2.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Serachg from "../../assets/images/Search-Icon-grey.svg";

import upload from "../../assets/images/uploadN.svg";

const EditForms = () => {
  const ref = useRef(null);
  const refs = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [loader, setLoader] = useState(true);
  const [sections, setSections] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const [sectionSubtitle, setSectionSubtitle] = useState("");
  const [sectionsName, setSectionsName] = useState("");
  const [media, setMedia] = useState(null);
  const [medias, setMedias] = useState(null);
  const [title, setTitle] = useState("");
  const [isRequired, setIsRequired] = useState(false);
  const [chatbotId, setChatbotId] = useState(null);
  const [mediaType, setMediaType] = useState("");
  const [mediasType, setMediasType] = useState("");
  const [image, setImage] = useState(null);
  const [images, setImages] = useState(null);
  const [addSection, setAddSection] = useState(false);
  const [sizeExceed, setSizeExceed] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const [modalState, setModalState] = useState(null);
  const [isLock, setIsLock] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [isSaveSectionTemplateOpen, setIsSaveSectionTemplateOpen] =
    useState(false);
  const [isImportSectionTemplateOpen, setIsImportSectionTemplateOpen] =
    useState(false);
  const [showOnboardingTemplates, setShowOnboardingTemplates] = useState(false);
  const [indx, setIndex] = useState(null);
  const [inx, setIndx] = useState(null);
  const [rename, setRename] = useState("");
  const [renameSubtitle, setRenameSubtitle] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [sectionTemplates, setSectionTemplates] = useState([]);
  const [onboardingTemplates, setOnblardingTemplates] = useState([]);
  const [files, setFiles] = useState([]);
  const [isEdit, setIsEdit] = useState(true);
  const [isNew, setIsNew] = useState(true);
  const [convertedDocuments, setConvertedDocuments] = useState([]);
  const [legalForms, setLegalForms] = useState([]);
  const [sectionId, setSectionId] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [templateId, setTemplateId] = useState(null);
  const [templateChatbotId, setTemplateChatbotId] = useState(null);
  const [deadLine, setDeadLine] = useState(null);
  const [type, setType] = useState("");
  const [company, setCompany] = useState([]);
  const [isNewSection, setIsNewSection] = useState(false);
  const [modalData, setModalDatas] = useState({});
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [sectionDeleteModal, setSectionDeleteModal] = useState(false);
  const [tempErr, setTempErr] = useState(false);
  const [sectionModalData, setSectionModalData] = useState({});
  const [filterCompany, setFilterCompany] = useState(0);
  const [templateTitle, setTemplateTitle] = useState("");
  const [idArray, setIdArray] = useState([]);
  const [error, setError] = useState(false);
  const isOtherInputSelected = useRef(false);
  const inputRef = useRef(null);
  const deadlineRef = useRef(null);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };
  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  useEffect(() => {
    let userData = JSON.parse(localStorage.getItem("UserAccess"));
    if (location.pathname === "/dashboard/onboarding/edit-forms") {
      setIsEdit(false);
      setIsNew(false);
      setCompany(userData?.Companies);
      if (userData?.Companies?.length === 0) {
        fetchJobs();
      } else {
        let companyId = localStorage.getItem("CompanyId");
        if (companyId === null) {
          setFilterCompany(userData?.Companies[0]?.id);
        } else {
          setFilterCompany(companyId);
        }
      }
    }
    if (
      location.pathname === "/dashboard/onboarding/edit-onboarding-template"
    ) {
      setIsEdit(true);
      setIsNew(false);
      let tempData = JSON.parse(localStorage.getItem("Tempdata"));
      console.log(tempData);
      console.log(location?.state?.item);
      setTemplateTitle(tempData?.template_name);
      viewTemplate(tempData?.id);
    }
    if (location.pathname === "/dashboard/onboarding/new-onboarding-template") {
      setIsNew(true);
      setIsEdit(false);
      setTemplateTitle("");
      setTemplateName("");
      setSections([]);
      // let tempData = JSON.parse(localStorage.getItem("Tempdata"));
      // console.log(tempData);
      // console.log(location?.state?.item);
      // setTemplateTitle(tempData?.template_name);
      // viewTemplate(tempData?.id);
    }
    fetchOnboardingTemplates();
  }, [location]);

  useEffect(() => {
    if (location.pathname === "/dashboard/onboarding/edit-forms") {
      setIsEdit(false);
      setIsNew(false);
      if (filterCompany !== 0) fetchCompanyJobs();
    }
  }, [filterCompany]);

  const stickyDiv = useRef();
  useEffect(() => {
    const tests = document.getElementById("test");
    tests.addEventListener("scroll", () => {
      const rightDiv = document.getElementById("scrollDiv");
      console.log(tests.scrollTop);
      let fixedTop = stickyDiv.current.offsetTop;
      // if (template.className === 'accordion-collapse wraper collapse' || template.className === 'accordion-collapse collapse wraper') {
      if (tests.scrollTop > 130) {
        rightDiv.classList.add("setupRightDiv");
      } else {
        rightDiv.classList.remove("setupRightDiv");
      }
      // }
      // if (template.className === 'accordion-collapse wraper collapse show') {
      // if (tests.scrollTop > 535) {
      //     mainHeader.classList.add('componentScroll')
      // } else {
      //     mainHeader.classList.remove('componentScroll')
      // }
      // }
    });
  }, []);

  useEffect(() => {
    if (location.pathname === "/dashboard/onboarding/edit-forms") {
      let userData = JSON.parse(localStorage.getItem("UserAccess"));
      if (userData?.Companies.length === 0) {
        let id = localStorage.getItem("ChatbotId");
        if (id === null) {
          if (jobs[0]?.id !== undefined) {
            setChatbotId(jobs[0]?.id);
            localStorage.setItem("ChatbotId", jobs[0]?.id);
          }
        } else {
          setChatbotId(id);
        }
      } else {
        let id = localStorage.getItem("ChatbotId");
        if (id === null) {
          if (jobs[0]?.id !== undefined) {
            setChatbotId(jobs[0]?.id);
            localStorage.setItem("ChatbotId", jobs[0]?.id);
          }
        } else {
          setChatbotId(id);
        }
      }
    }
  }, [jobs]);

  useEffect(() => {
    if (location.pathname === "/dashboard/onboarding/edit-forms") {
      console.log(chatbotId);
      if (chatbotId !== null) {
        fetchSections();
      }
    }
  }, [chatbotId]);

  const viewTemplate = async () => {
    setLoader(true);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formData = {
      templateid: tempData?.id,
    };
    await ApiHelper.post(API.getTemplateDetails, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          console.log(resData?.data?.templateData[0]);
          setSections(resData?.data?.templateData[0]?.template_data);
          setDeadLine(resData?.data?.templateData[0]?.deadline);

          if (resData?.data?.templateData[0]?.send_otp === 1) setIsVerify(true);
          if (resData?.data?.templateData[0]?.send_otp === 0)
            setIsVerify(false);
          if (resData.data?.templateData[0]?.lock_status === 1) setIsLock(true);
          if (resData.data?.templateData[0]?.lock_status === 0)
            setIsLock(false);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  const fetchSections = async () => {
    setLoader(true);
    const formData = {
      chatbotid: chatbotId,
    };
    await ApiHelper.post(API.getSections, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setSections(resData.data.data);
          setDeadLine(resData.data?.options?.deadline);
          if (resData?.data?.options?.send_otp === 1) setIsVerify(true);
          if (resData?.data?.options?.send_otp === 0) setIsVerify(false);
          if (resData.data.options.lock_status === 1) setIsLock(true);
          if (resData.data.options.lock_status === 0) setIsLock(false);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const fetchJobs = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
    };
    await ApiHelper.post(API.getJobs, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setJobs(resData.data.data);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const fetchCompanyJobs = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      companyId: filterCompany,
    };
    await ApiHelper.post(API.getCompanyJobs, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setJobs(resData.data.data);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      if (showOnboardingTemplates) {
        fetchOnboardingTemplates();
      } else {
        fetchSectionTemplates();
      }
    }, 500);
    return () => {
      clearTimeout(getData);
    };
  }, [searchKey]);

  const fetchSectionTemplates = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      searchkey: searchKey,
    };
    await ApiHelper.post(API.getSectionTemplates, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          setSectionTemplates(resData.data.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const deleteSectionTemplate = async (id) => {
    setLoader(true);
    const formData = {
      templateid: id,
    };
    await ApiHelper.post(API.deleteSectionTemplate, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          fetchSectionTemplates();
          setSectionDeleteModal(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const alterPopups = (item) => {
    if (item === "Media") {
      setIsCreateFormOpen(false);
      setIsUploadOpen(true);
    } else {
      setIsCreateFormOpen(true);
      setIsUploadOpen(false);
    }
  };

  const uploadMedia = async () => {
    setLoader(true);
    let formData = new FormData();
    formData.append("sectionname", sectionName);
    formData.append("onboarding_media_files", media);
    formData.append("isrequired", isRequired ? 1 : 0);
    formData.append("title", title);
    formData.append("description", "");
    formData.append("chatbotid", chatbotId);
    formData.append("fieldid", mediaType);
    await ApiHelper.mediapost(API.uploadMedia, formData)
      .then((resData) => {
        console.group(resData);
        if (resData.data.success === true) {
          setIsUploadOpen(false);
          {
            isEdit || isNew ? viewTemplate() : fetchSections();
          }
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const uploadMedias = async () => {
    setLoader(true);
    let formData = new FormData();
    formData.append("sectionname", sectionsName);
    formData.append("onboarding_media_files", medias);
    formData.append("isrequired", 1);
    formData.append("title", "");
    formData.append("description", "");
    formData.append("chatbotid", chatbotId);
    formData.append("fieldid", mediasType);
    await ApiHelper.mediapost(API.uploadMedia, formData)
      .then((resData) => {
        console.group(resData);
        if (resData.data.success === true) {
          // setAddSection(false)
          setSectionsName("");
          setMediasType(0);
          setImages(null);
          fetchSections();
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setMedia(event.target.files[0]);
      setImage(URL.createObjectURL(event.target.files[0]));
    }
  };

  const onImagesChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 52428800) {
        setSizeExceed(true);
      } else {
        if (JSON.stringify(event.target.files[0].type).includes("image")) {
          setIsImage(true);
        }
        if (JSON.stringify(event.target.files[0].type).includes("video")) {
          setIsImage(false);
        }
        setSizeExceed(false);
        setMedias(event.target.files[0]);
        setImages(URL.createObjectURL(event.target.files[0]));
      }
    }
  };

  const handleClickScroll = () => {
    const element = document.getElementById("section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      handleInputClick();
    }
  };

  const saveTemplate = async () => {
    if (templateName !== "") {
      setLoader(true);
      let user = JSON.parse(localStorage.getItem("UserData"));
      let sectionid = [];
      sections.map((item) => {
        sectionid.push(item?.id);
      });
      const formData = {
        userid: user?.id,
        templatename: templateName,
        sectionids: sectionid,
        chatbotid: chatbotId,
        overwrite: 0,
      };
      await ApiHelper.post(API.saveSectionTemplates, formData)
        .then((resData) => {
          if (resData.data.success === true) {
            toast("Template saved successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setIsSaveSectionTemplateOpen(false);
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      toast("Template name cannot be empty!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const saveSectionTemplate = async () => {
    if (templateName !== "") {
      setLoader(true);
      let user = JSON.parse(localStorage.getItem("UserData"));
      let sectionid = [];
      sections.map((item) => {
        sectionid.push(item?.id);
      });
      const formData = {
        userid: user?.id,
        template_name: templateName,
      };
      await ApiHelper.post(API.createSectionTemplates, formData)
        .then((resData) => {
          console.log(resData);
          if (resData.data.success === true) {
            // toast("Template saved successfully", {
            //   position: "top-right",
            //   autoClose: 5000,
            //   hideProgressBar: true,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   theme: "light",
            // });
            navigate("/dashboard/onboarding/edit-onboarding-template");
            localStorage.setItem(
              "Tempdata",
              JSON?.stringify(resData?.data?.templateData[0])
            );
            setIsSaveSectionTemplateOpen(false);
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      toast("Template name cannot be empty!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const importTemplate = async () => {
    if (templateId !== null) {
      setLoader(true);
      let formData = {};
      let formDataTemp = {};
      let tempData = JSON.parse(localStorage.getItem("Tempdata"));
      if (isNewSection === true) {
        if (isEdit || isNew) {
          formDataTemp = {
            template_id: idArray.length > 1 ? idArray : templateId,
            currenttemplateid: tempData?.id,
            template_section_name:
              sectionName !== "" ? sectionName : "New Section",
            template_section_subtitle: sectionSubtitle,
            type: type,
          };
        } else {
          formData = {
            templateid: templateId,
            chatbotid: parseInt(chatbotId),
            sectionname: sectionName !== "" ? sectionName : "New Section",
            sectionsubtitle: sectionSubtitle,
            type: type,
          };
        }
        // if (showOnboardingTemplates) {
        // formData.type = type;
      } else {
        if (isEdit || isNew) {
          formDataTemp = {
            template_id: idArray.length > 1 ? idArray : templateId,
            sectionid: sectionId,
            type: type,
          };
        } else {
          formData = {
            templateid: templateId,
            [showOnboardingTemplates ? "sectionid" : "chatbotid"]:
              showOnboardingTemplates ? sectionId : chatbotId,
            type: type,
          };
        }
        // if (showOnboardingTemplates) {
        // formData.type = type;
      }
      await ApiHelper.post(
        isEdit || isNew
          ? API.saveTemplateToOnboardingForm
          : showOnboardingTemplates
          ? API.saveTemplateToForm
          : API.importSectionTemplates,
        isEdit || isNew ? formDataTemp : formData
      )
        .then((resData) => {
          if (resData.data.success === true) {
            setIdArray([]);
            if (showOnboardingTemplates) {
              setShowOnboardingTemplates(false);
            } else {
              setIsImportSectionTemplateOpen(false);
            }
            setAddSection(false);
            setTemplateId(null);
            setSectionName("");
            setSectionSubtitle("");
            isEdit || isNew ? viewTemplate() : fetchSections();
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  const setModalData = (data) => {
    setModalState(data);
    if (data?.is_required === 1) setIsRequired(true);
    if (data?.is_required === 0) setIsRequired(false);
    setMediaType(data?.fields?.[0]?.field_type_id);
    setTitle(data?.title);
  };

  const onDragEnd = async (result) => {
    console.log(result);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    if (result?.destination !== null) {
      if (result.type === "section") {
        setLoader(true);
        const formData = {
          chatbotid: chatbotId,
          draggingSection: parseInt(result.draggableId),
          currentSection: sections[result.destination.index].id,
        };
        const formDataTemp = {
          template_id: tempData?.id,
          draggingSection: parseInt(result.draggableId),
          currentSection: sections[result.destination.index].id,
        };
        await ApiHelper.post(
          isEdit || isNew ? API.changeTempSectionOrder : API.changeSectionOrder,
          isEdit || isNew ? formDataTemp : formData
        )
          .then((resData) => {
            if (resData.data.success === true) setRename("");
            setIndex(null);
            setIndx(null);
            setRenameSubtitle("");
            {
              isEdit || isNew ? viewTemplate() : fetchSections();
            }
            setLoader(false);
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
      if (result.type === "form") {
        setLoader(true);
        let currentForm = 0;
        for (let i = 0; i < sections?.length; i++) {
          if (sections[i]?.id === parseInt(result?.destination?.droppableId)) {
            console.log(
              sections[i]?.template_forms[result?.destination?.index]?.id
            );
            if (isEdit || isNew) {
              if (
                sections[i]?.template_forms[result?.destination?.index]?.id !==
                undefined
              )
                currentForm =
                  sections[i]?.template_forms[result?.destination?.index]?.id;
            } else {
              if (
                sections[i]?.section_forms[result?.destination?.index]?.id !==
                undefined
              )
                currentForm =
                  sections[i]?.section_forms[result?.destination?.index]?.id;
            }
          }
        }
        console.log(currentForm);
        if (currentForm !== undefined) {
          const formData = {
            draggingForm: parseInt(result.draggableId),
            currentForm: currentForm,
            currentSection: parseInt(result.destination.droppableId),
          };
          console.log(formData);
          await ApiHelper.post(
            isEdit || isNew ? API.changeTempFormOrder : API.changeFormOrder,
            formData
          )
            .then((resData) => {
              console.log(resData);
              if (resData.data.success === true) setRename("");
              setIndex(null);
              setIndx(null);
              setRenameSubtitle("");
              {
                isEdit || isNew ? viewTemplate() : fetchSections();
              }
              setLoader(false);
            })
            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        } else {
          setLoader(false);
        }
      }
    }
  };

  const addNewSection = async (event) => {
    if (loader === false) {
      if (event.key === "Enter") {
        setLoader(true);
        const formData = {
          chatbotid: chatbotId,
          sectionname: sectionName === "" ? "New Section" : sectionName,
          subtitle: sectionSubtitle,
        };
        let tempData = JSON.parse(localStorage.getItem("Tempdata"));
        const formDataTemp = {
          template_id: tempData?.id,
          template_section_name:
            sectionName === "" ? "New Section" : sectionName,
          template_section_subtitle: sectionSubtitle,
        };
        await ApiHelper.post(
          isEdit || isNew ? API.addTemplateSection : API.addSection,
          isEdit || isNew ? formDataTemp : formData
        )
          .then((resData) => {
            if (resData.data.success === true) {
              inputRef.current.blur();
              setSectionName("");
              setSectionSubtitle("");
              {
                isEdit || isNew ? viewTemplate() : fetchSections();
              }
              setAddSection(false);
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
    }
  };

  function handleCheckboxChange(id) {
    let itemId = id.toString();
    if (idArray.includes(itemId)) {
      setIdArray((prev) => prev.filter((id) => id !== itemId));
    } else {
      setIdArray((prev) => [...prev, itemId]);
    }
  }

  const addNewSectionBlur = async (event) => {
    if (loader === false) {
      setTimeout(() => {
        if (!isOtherInputSelected.current) {
          sectionAdd();
        }
      }, 100);
    }
  };

  const sectionAdd = async () => {
    setLoader(true);
    const formData = {
      chatbotid: chatbotId,
      sectionname: sectionName === "" ? "New Section" : sectionName,
      subtitle: sectionSubtitle,
    };
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formDataTemp = {
      template_id: tempData?.id,
      template_section_name: sectionName === "" ? "New Section" : sectionName,
      template_section_subtitle: sectionSubtitle,
    };
    await ApiHelper.post(
      isEdit || isNew ? API.addTemplateSection : API.addSection,
      isEdit || isNew ? formDataTemp : formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          setSectionName("");
          setSectionSubtitle("");
          {
            isEdit || isNew ? viewTemplate() : fetchSections();
          }
          setAddSection(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  const renameSection = async (event, id) => {
    if (event.key === "Enter") {
      event.target.blur();
    }
  };

  const renameSectionBlur = async (event, id) => {
    if (rename.trim() !== "") {
      setLoader(true);
      const formData = {
        sectionid: id,
        sectionname: rename,
      };
      const formDataTemp = {
        template_section_id: id,
        template_section_name: rename,
      };
      await ApiHelper.post(
        isEdit || isNew ? API.renameTemplateSection : API.renameSection,
        isEdit || isNew ? formDataTemp : formData
      )
        .then((resData) => {
          if (resData.data.success === true) {
            setRename("");
            setIndex(null);
            setRename("");
            {
              isEdit || isNew ? viewTemplate() : fetchSections();
            }
            setLoader(false);
          } else {
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      toast("Section name cannot be empty!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIndex(null);
      setRename("");
      {
        isEdit || isNew ? viewTemplate() : fetchSections();
      }
    }
  };

  const renameSectionSubtitleBlur = async (event, id) => {
    setLoader(true);
    const formData = {
      sectionid: id,
      subtitle: renameSubtitle,
    };
    const formDataTemp = {
      template_section_id: id,
      template_section_subtitle: renameSubtitle,
    };
    await ApiHelper.post(
      isEdit || isNew
        ? API.renameTemplateSubSection
        : API.renameSectionSubtitle,
      isEdit || isNew ? formDataTemp : formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          setRenameSubtitle("");
          setIndx(null);
          {
            isEdit || isNew ? viewTemplate() : fetchSections();
          }
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const renameSectionSubtitle = async (event, id) => {
    if (event.key === "Enter") {
      setLoader(true);
      const formData = {
        sectionid: id,
        subtitle: renameSubtitle,
      };
      const formDataTemp = {
        template_section_id: id,
        template_section_subtitle: renameSubtitle,
      };
      await ApiHelper.post(
        isEdit || isNew
          ? API.renameTemplateSubSection
          : API.renameSectionSubtitle,
        isEdit || isNew ? formDataTemp : formData
      )
        .then((resData) => {
          if (resData.data.success === true) {
            setRenameSubtitle("");
            setIndx(null);
            {
              isEdit || isNew ? viewTemplate() : fetchSections();
            }
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  const deleteForm = async (id) => {
    setLoader(true);
    const formData = {
      sectiondataid: id,
    };
    await ApiHelper.post(
      isEdit || isNew ? API.deleteTempForm : API.deleteForm,
      formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          {
            isEdit || isNew ? viewTemplate() : fetchSections();
          }
          closeModal();
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const lockFlow = async () => {
    setLoader(true);

    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    setLoader(true);
    const formData = {
      chatbot_id: chatbotId,
      lock_status: isLock ? 0 : 1,
    };
    const formDataTemp = {
      id: tempData?.id,
      lock_status: isLock ? 0 : 1,
    };
    await ApiHelper.post(
      isEdit ? API.onboardingTempUpdate : API.onboardingUpdate,
      isEdit ? formDataTemp : formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          isEdit ? viewTemplate() : fetchSections();
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const manageSendOtp = async () => {
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    setLoader(true);
    const formData = {
      chatbot_id: chatbotId,
      send_otp: isVerify ? 0 : 1,
    };
    const formDataTemp = {
      id: tempData?.id,
      send_otp: isVerify ? 0 : 1,
    };
    await ApiHelper.post(
      isEdit ? API.onboardingTempUpdate : API.onboardingUpdate,
      isEdit ? formDataTemp : formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          isEdit ? viewTemplate() : fetchSections();
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const setDeadlineOnEnter = async (event) => {
    if (event.key === "Enter") {
      if (parseInt(deadLine) !== 0) {
        setLoader(true);
        const formData = {
          chatbot_id: chatbotId,
          deadline: parseInt(deadLine),
        };
        await ApiHelper.post(API.onboardingUpdate, formData)
          .then((resData) => {
            if (resData.data.success === true)
              // fetchSections()
              deadlineRef.current.blur();
            setLoader(false);
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      } else {
        console.log("Zero");
      }
    }
  };

  const setDeadline = async () => {
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    if (parseInt(deadLine) !== 0) {
      setLoader(true);
      const formData = {
        chatbot_id: chatbotId,
        deadline: parseInt(deadLine),
      };
      const formDataTemp = {
        id: tempData?.id,
        deadline: parseInt(deadLine),
      };
      await ApiHelper.post(
        isEdit ? API.onboardingTempUpdate : API.onboardingUpdate,
        isEdit ? formDataTemp : formData
      )
        .then((resData) => {
          if (resData.data.success === true)
            // fetchSections()
            setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      console.log("Zero");
    }
  };

  const handleScroll = (item) => {
    const element = document.getElementById("formitem" + item);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  async function fetchOnboardingTemplates() {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const obj = {
      userid: user?.id,
      searchkey: searchKey,
    };
    await ApiHelper.post(API.fetchOnboardingTemplates, obj)
      .then((resData) => {
        if (resData.data.success === true) {
          console.log("resDataresData", resData);
          setOnblardingTemplates(resData.data.data);
          setConvertedDocuments(resData.data.convertedDocuments);
          setFiles(resData.data.Files);
          setLegalForms(resData.data.LegalForms);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }

  const deleteSection = async (id) => {
    setLoader(true);
    const formData = {
      sectionid: id,
    };
    await ApiHelper.post(
      isEdit || isNew ? API.deleteTempSection : API.deleteSection,
      formData
    )
      .then((resData) => {
        if (resData.data.success === true) {
          {
            isEdit || isNew ? viewTemplate() : fetchSections();
          }
          closeModal();
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const updateTempName = async () => {
    setLoader(true);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formData = {
      templateid: tempData?.id,
      template_name: templateTitle,
    };
    await ApiHelper.post(API.updateTempName, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          {
            isEdit || isNew ? viewTemplate() : fetchSections();
          }
          closeModal();
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  const editNavigateFunction = async (data, item) => {
    let newItemObj;
    if (isEdit || isNew) {
      if (data.subtitle == "converted document") {
        setLoader(true);
        const obj = {
          formfieldid: data.fields[0].id,
        };
        try {
          const result = await ApiHelper.post(
            isEdit || isNew
              ? API.onboardingGetTemplateConvertedDocument
              : API.onboardingGetSectionConvertedDocument,
            obj
          );
          console.log("result", result);
          newItemObj = {
            file_buffer_encrypted_value: result.data.b64Doc,
            details: result.data.data,
            id: data.id,
            data: result.config.data,
          };
          if (
            location.pathname ===
            "/dashboard/onboarding/edit-onboarding-template"
          ) {
            navigate("/dashboard/onboarding/edit-pdf-form", {
              state: { item: newItemObj },
            });
          } else navigate("/dashboard/upload", { state: { item: newItemObj } });
          setLoader(false);
        } catch (err) {
          console.log("err", err);
        }
      } else {
        localStorage.setItem("tempId", item.template_id);
        navigate("/dashboard/onboarding/edit-onboarding-template-form", {
          state: { item: data, data: item },
        });
      }
    } else {
      if (data.subtitle == "converted document") {
        setLoader(true);
        const obj = {
          formfieldid: data.fields[0].id,
        };
        try {
          const result = await ApiHelper.post(
            API.onboardingGetSectionConvertedDocument,
            obj
          );
          newItemObj = {
            file_buffer_encrypted_value: result.data.b64Doc,
            details: result.data.data,
            id: data.id,
            data: result.config.data,
          };
          navigate("/dashboard/upload", { state: { item: newItemObj } });
          setLoader(false);
        } catch (err) {
          console.log("err", err);
        }
      } else {
        navigate("/dashboard/onboarding/edit-form", { state: { item: data } });
      }
    }
  };
  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
  });

  const handleFocus = () => {
    isOtherInputSelected.current = true;
  };

  const inputBlur = () => {
    isOtherInputSelected.current = false;
    setTimeout(() => {
      if (sectionName !== "" || sectionSubtitle !== "") {
        if (isOtherInputSelected.current === false) addNewSectionBlur();
      }
    }, 100);
  };

  const handleInputClick = () => {
    inputRef.current.focus();
  };

  return (
    <div
      className="content-sc edits-height-box "
      id="test"
      onClick={() => {
        isNew && templateName === "" ? setTempErr(true) : setTempErr(false);
      }}
    >
      <div className="sidebar_open custom-lay">
        <div style={{ position: "fixed" }} ref={stickyDiv}></div>
        {!isEdit && !isNew && (
          <div className=" mt-2">
            <div className="col-md-12 ">
              <div class="row  d-flex align-items-center">
                <div class="team-member onbording-name-div col-md-8">
                  <li className="list-group-item same-line mb-3">
                    <div className="filterAlign">
                      <div className="row">
                        {company?.length !== 0 && (
                          <div className="col-sm-3 col-lg-3">
                            <div className="main-filter">
                              {/*<p className="filter-name">Company :</p>*/}
                              <select
                                class="form-select drop-filter customFilt"
                                value={filterCompany}
                                onChange={(e) => {
                                  setFilterCompany(e.target.value);
                                  localStorage.removeItem("ChatbotId");
                                  localStorage.setItem(
                                    "CompanyId",
                                    e.target.value
                                  );
                                }}
                              >
                                {company?.map((item) => {
                                  return (
                                    <option value={item?.id}>
                                      {" "}
                                      {item?.company_name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}

                        {jobs.length !== 0 && (
                          <div className="col-sm-3 col-lg-3">
                            <div className="main-filter">
                              {/*<p className="filter-name">Job :</p>*/}
                              <select
                                class="form-select drop-filter customFilt"
                                value={chatbotId}
                                onChange={(e) => {
                                  setChatbotId(e.target.value);
                                  localStorage.setItem(
                                    "ChatbotId",
                                    e.target.value
                                  );
                                  setRename("");
                                  setIndex(null);
                                }}
                              >
                                {jobs?.map((item) => {
                                  return (
                                    <option value={item?.id}>
                                      {item?.chatbot_name}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                </div>

                <div class="search serach-width-div col-md-4">
                  <div className="onb-actions fontSty edits-fil">
                    {/* <select className='form-control' >
          <option selected>Upload</option>
          <option> option 1</option>
          <option> option 1</option>
        </select> */}
                    <a
                      className="btn-primary"
                      onClick={() => {
                        localStorage.setItem("prevRoute", location.pathname);
                        navigate("/preview", {
                          state: { chatbotId: chatbotId, section: true },
                        });
                      }}
                    >
                      {" "}
                      <img src={Eye} alt="test" className="menu_icon" /> Preview
                    </a>
                    <a className="btn-primary" onClick={lockFlow}>
                      {/* <img src={isLock ? Unlock : Lock} alt="test" className="menu_icon" />*/}
                      <div className="outer-tool">
                        <div class="tooltip">
                          <img
                            src={isLock ? Unlock : Lock}
                            alt="test"
                            className="menu_icon"
                          />
                          <span class="tooltiptext lock-tip">
                            In a locked flow, onboarding employees are required
                            to complete all sections in order.
                          </span>
                        </div>
                      </div>
                      {isLock ? "Unlock Flow" : "Lock Flow"}
                    </a>

                    {/* <div className='info'>
          <img src={Info} alt="test" className="menu_icon" />
        </div> */}
                  </div>
                </div>
              </div>

              <iframe
                id="pdfViewer"
                width="100%"
                height="600px"
                style={{ border: "1px solid #ccc", display: "none" }}
              />
            </div>
          </div>
        )}
        {(isEdit || isNew) && (
          <div className="action-itms full-drp wrapAlign padNew cer-temps mt-2 ">
            <div className="wraper txtAlgn p-0 ">
              <div className="  col-lg-12   ">
                <div className="d-flex justify-content-between align-items-center">
                  <div
                    className="form-floating creat-form-inputss "
                    style={{
                      border:
                        error === true &&
                        (templateTitle === "" || templateTitle === null)
                          ? "1px solid red"
                          : null,
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      id="signHereInput"
                      placeholder="Number of Days"
                      value={isNew ? templateName : templateTitle}
                      style={{
                        border:
                          isNew && tempErr === true ? "1px solid red" : null,
                      }}
                      onChange={(e) => {
                        isNew
                          ? setTemplateName(e.target.value)
                          : setTemplateTitle(e.target.value);
                      }}
                      onBlur={() => {
                        !isNew && updateTempName();
                      }}
                    />
                    <label
                      htmlFor="signHereInput"
                      style={{ color: "#A4A4A4", fontSize: "14px" }}
                    >
                      Template Name
                    </label>
                  </div>
                  {/* <p className="subHead top-texts-create">
                    Manage your custom template by choosing from the selection
                    of components below.
                  </p> */}

                  <div class="search serach-width-div col-md-4 ">
                    <div className="onb-actions fontSty edits-fil">
                      <a
                        className="btn-primary"
                        onClick={() => {
                          localStorage.setItem("prevRoute", location.pathname);
                          navigate("/preview", {
                            state: { section: true },
                          });
                        }}
                      >
                        {" "}
                        <img src={Eye} alt="test" className="menu_icon" />{" "}
                        Preview
                      </a>

                      <a className="btn-primary" onClick={lockFlow}>
                        {/* <img src={isLock ? Unlock : Lock} alt="test" className="menu_icon" />*/}
                        <div className="outer-tool">
                          <div class="tooltip">
                            <img
                              src={isLock ? Unlock : Lock}
                              alt="test"
                              className="menu_icon"
                            />
                            <span class="tooltiptext lock-tip">
                              In a locked flow, onboarding employees are
                              required to complete all sections in order.
                            </span>
                          </div>
                        </div>
                        {isLock ? "Unlock Flow" : "Lock Flow"}
                      </a>
                    </div>
                  </div>
                  {/* {isNew && (
                    <button
                      className="Save top-save-bbtn"
                      onClick={saveSectionTemplate}
                    >
                      Save
                    </button>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {console.log(jobs?.length !== 0, chatbotId, isEdit, isNew)}
      {(jobs?.length !== 0 && chatbotId !== null) || isEdit || isNew ? (
        <div className="row">
          <div className="col-lg-9 col-md-8 hight-av">
            <div className="sidebar_open main-content edit hight-av">
              <div className="form-features bxShw wraper outer_bord scrollling-editzz">
                {sections?.length !== 0 ? (
                  isEdit === true || isNew === true ? (
                    <>
                      <div className="wraper mt-2">
                        <div className="action-itms-forms-main formInner b-0 wraper">
                          <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="section" type="section">
                              {(provided) => (
                                <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {sections?.map((item, index) => {
                                    return (
                                      <Draggable
                                        key={item?.id}
                                        draggableId={item?.id.toString()}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            className="form-features newone"
                                            {...provided.draggableProps}
                                            ref={provided.innerRef}
                                            {...provided.dragHandleProps}
                                          >
                                            <Droppable
                                              droppableId={item?.id.toString()}
                                              type="form"
                                            >
                                              {(provided) => (
                                                <div
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  <div className="form-features newone">
                                                    <div className="bxborder wraper newPads_editform">
                                                      <h6 className="form-hd d-flex justify-content-between mb-4 formAlg-new align-items-center">
                                                        <div className="inpSpace">
                                                          <img
                                                            src={sdot}
                                                            alt="test"
                                                            className="dragBtn-fist mrR"
                                                          />
                                                          <div className="inpAlig">
                                                            <input
                                                              className="subHead_inp main-title titile-head-width"
                                                              type="text"
                                                              placeholder="Enter Sectionname"
                                                              onFocus={() => {
                                                                setIndex(index);
                                                                setRename(
                                                                  item?.template_section_name
                                                                );
                                                              }}
                                                              value={
                                                                indx === index
                                                                  ? rename
                                                                  : item?.template_section_name
                                                              }
                                                              onChange={(e) => {
                                                                setRename(
                                                                  e.target.value
                                                                );
                                                              }}
                                                              onKeyDown={(
                                                                e
                                                              ) => {
                                                                renameSection(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                              onBlur={(e) => {
                                                                renameSectionBlur(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                            />
                                                            <input
                                                              className="subHead_inp titile-head-width"
                                                              type="text "
                                                              placeholder="Enter Subtitle"
                                                              onClick={() => {
                                                                setIndx(index);
                                                                setRenameSubtitle(
                                                                  item?.template_section_subtitle
                                                                );
                                                              }}
                                                              value={
                                                                inx === index
                                                                  ? renameSubtitle
                                                                  : item?.template_section_subtitle
                                                              }
                                                              onChange={(e) => {
                                                                setRenameSubtitle(
                                                                  e.target.value
                                                                );
                                                              }}
                                                              onKeyDown={(
                                                                e
                                                              ) => {
                                                                renameSectionSubtitle(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                              onBlur={(e) => {
                                                                renameSectionSubtitleBlur(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                        <div className="btnSpace">
                                                          {/* {indx !== null || inx !== null ? <button className='head-close border-0 ms-5 clsBt' onClick={() => {
                                            setRename('')
                                            setIndex(null);
                                            setIndx(null);
                                            setRenameSubtitle('');
                                          }}><img src={close} alt="test" className="menu_icon" /></button> : */}
                                                          <button
                                                            className="head-close border-0 ms-5 clsBt"
                                                            onClick={() => {
                                                              setModalDatas({
                                                                item: "Section",
                                                                itemId:
                                                                  item?.id,
                                                                itemName:
                                                                  item?.template_section_name,
                                                              });
                                                              openModal();
                                                            }}
                                                          >
                                                            <img
                                                              src={trash}
                                                              alt="test"
                                                              className="menu_icon"
                                                            />
                                                          </button>
                                                        </div>
                                                      </h6>
                                                      <div className="f-group">
                                                        {item?.template_forms?.map(
                                                          (data, ind) => {
                                                            return (
                                                              <Draggable
                                                                key={data.id}
                                                                draggableId={data?.id.toString()}
                                                                index={ind}
                                                              >
                                                                {(
                                                                  provided,
                                                                  snapshot
                                                                ) => (
                                                                  <div
                                                                    id={
                                                                      "formitem" +
                                                                      data?.id
                                                                    }
                                                                    className="f-itm newOne bor_drag"
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    ref={
                                                                      provided.innerRef
                                                                    }
                                                                  >
                                                                    <div className="leftDivs">
                                                                      <button className="btn dragBtn">
                                                                        <img
                                                                          src={
                                                                            sdot
                                                                          }
                                                                          alt="test"
                                                                          className="menu_icon"
                                                                        />
                                                                      </button>
                                                                      <span className="form-name-edit">
                                                                        {/* <img src={star} alt="test" className="menu_icon" />  */}

                                                                        {/* <img src={video} alt="test" className="menu_icon" /> */}
                                                                        {
                                                                          data?.title
                                                                        }
                                                                        {data
                                                                          ?.fields[0]
                                                                          ?.field_type_id ===
                                                                          13 && (
                                                                          <img
                                                                            src={
                                                                              filetext
                                                                            }
                                                                            alt="test"
                                                                            className="filetext-img "
                                                                          />
                                                                        )}
                                                                      </span>
                                                                    </div>
                                                                    <div className="d-flex">
                                                                      <div className="f-btns ediBtns">
                                                                        {data?.template_type ===
                                                                          "i-9form" ||
                                                                        data?.template_type ===
                                                                          "w4-form" ||
                                                                        data?.template_type ===
                                                                          "W4Sc-form" ||
                                                                        data?.template_type ===
                                                                          "direct-deposit" ||
                                                                        data?.template_type ===
                                                                          "Ohio-it4-combined" ||
                                                                        data?.subtitle ===
                                                                          "adminI9Pdf" ||
                                                                        data?.template_type ===
                                                                          "MI-W4_Form" ||
                                                                        data?.template_type ===
                                                                          "AR4EC-pdf" ||
                                                                        data?.template_type ===
                                                                          "L4-pdf" ? (
                                                                          <div></div>
                                                                        ) : (
                                                                          <button
                                                                            className="btn"
                                                                            onClick={() => {
                                                                              editNavigateFunction(
                                                                                data,
                                                                                item
                                                                              );
                                                                            }}
                                                                          >
                                                                            <div class="tooltip">
                                                                              <img
                                                                                src={
                                                                                  edit
                                                                                }
                                                                                alt="test"
                                                                                className="menu_icon bfBtn"
                                                                              />
                                                                              <img
                                                                                src={
                                                                                  editA
                                                                                }
                                                                                alt="test"
                                                                                className="menu_icon Actbtn"
                                                                              />
                                                                              <span class="tooltiptext edit-tip">
                                                                                Edit
                                                                              </span>
                                                                            </div>
                                                                          </button>
                                                                        )}
                                                                        {data?.template_type ===
                                                                          "i-9form" ||
                                                                        data?.template_type ===
                                                                          "w4-form" ||
                                                                        data?.subtitle ===
                                                                          "adminI9Pdf" ||
                                                                        data?.template_type ===
                                                                          "direct-deposit" ||
                                                                        data?.template_type ===
                                                                          "Ohio-it4-combined" ||
                                                                        data?.template_type ===
                                                                          "W4Sc-form" ||
                                                                        data?.template_type ===
                                                                          "MI-W4_Form" ||
                                                                        data?.template_type ===
                                                                          "AR4EC-pdf" ||
                                                                        data?.template_type ===
                                                                          "L4-pdf" ? (
                                                                          <></>
                                                                        ) : (
                                                                          <span
                                                                            style={{
                                                                              color:
                                                                                "rgb(102 102 102 / 29%)",
                                                                            }}
                                                                          >
                                                                            &nbsp;|&nbsp;
                                                                          </span>
                                                                        )}
                                                                      </div>

                                                                      <div className="f-btns deletBtns">
                                                                        <button
                                                                          className="btn"
                                                                          onClick={() => {
                                                                            setModalDatas(
                                                                              {
                                                                                item: "Form",
                                                                                itemId:
                                                                                  data.id,
                                                                                itemName:
                                                                                  data.title,
                                                                              }
                                                                            );
                                                                            openModal();
                                                                          }}
                                                                        >
                                                                          <div class="tooltip">
                                                                            <img
                                                                              src={
                                                                                trash
                                                                              }
                                                                              alt="test"
                                                                              className="menu_icon bfsBtn"
                                                                            />
                                                                            <svg
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              width="20"
                                                                              height="18"
                                                                              viewBox="0 0 20 22"
                                                                              fill="none"
                                                                              className="menu_icon Actsbtn"
                                                                            >
                                                                              <path
                                                                                d="M1 5H3H19"
                                                                                stroke="#3A68D8"
                                                                                stroke-width="2"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round"
                                                                              />
                                                                              <path
                                                                                d="M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5"
                                                                                stroke="#3A68D8"
                                                                                stroke-width="2"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round"
                                                                              />
                                                                            </svg>
                                                                            <span class="tooltiptext edit-tip">
                                                                              Delete
                                                                            </span>
                                                                          </div>
                                                                        </button>
                                                                        {/* <button className='btn'><img src={sdot} alt="test" className="menu_icon" /></button> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                )}
                                                              </Draggable>
                                                            );
                                                          }
                                                        )}
                                                      </div>

                                                      <div className="choose-files d-flex justify-content-center wraper mt-4 mb-0">
                                                        <div className="upload-btns d-flex align-items-center">
                                                          <button
                                                            onClick={() => {
                                                              setIsNewSection(
                                                                false
                                                              );
                                                              setShowOnboardingTemplates(
                                                                true
                                                              );
                                                              setSectionId(
                                                                item?.id
                                                              );
                                                            }}
                                                            className="up-btn btn mr-0 choose-text"
                                                          >
                                                            Choose Form
                                                          </button>
                                                          <h6 className="mx-4 or-text">
                                                            or
                                                          </h6>
                                                          <a
                                                            onClick={() => {
                                                              navigate(
                                                                "/dashboard/onboarding/create-onboarding-template-form",
                                                                {
                                                                  state: {
                                                                    item: item,
                                                                  },
                                                                }
                                                              );
                                                            }}
                                                            className="createa form"
                                                          >
                                                            Create New Form
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </Droppable>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        </div>
                      </div>
                      <div
                        className="form-features mt-4 formInner formWarp p-0 wraper"
                        id="section"
                      >
                        <h6 className="form-hd d-flex justify-content-between formAlg-new align-items-center">
                          <div className="inpSpace">
                            <img src={sdot} alt="test" className="menu_icon" />
                            <div className="inpAlig">
                              <input
                                className="subHead_inp main-title titile-head-width"
                                ref={inputRef}
                                type="text"
                                placeholder="New Section"
                                value={sectionName}
                                onFocus={handleFocus}
                                onChange={(e) => {
                                  setSectionName(e.target.value);
                                }}
                                onKeyDown={addNewSection}
                                onBlur={() => {
                                  (sectionName !== "" ||
                                    sectionSubtitle !== "") &&
                                    addNewSectionBlur();
                                }}
                              />
                              {/* <p className='subtits'>gfsagsa</p> */}
                              <input
                                className="subHead_inp titile-head-width"
                                type="text"
                                placeholder="Enter Subtitle"
                                value={sectionSubtitle}
                                onFocus={handleFocus}
                                onChange={(e) => {
                                  setSectionSubtitle(e.target.value);
                                }}
                                onKeyDown={addNewSection}
                                onBlur={inputBlur}
                              />
                            </div>
                          </div>
                          <div className="btnSpace">
                            <button
                              className="head-close border-0 clsBt ms-5"
                              onClick={() => {
                                setSectionName("");
                                setSectionSubtitle("");
                                setAddSection(false);
                              }}
                            >
                              {" "}
                              <img
                                src={close}
                                alt="test"
                                className="menu_icon"
                              />{" "}
                            </button>
                          </div>
                        </h6>

                        <div
                          className={
                            sizeExceed
                              ? "fileuploadExceed"
                              : "fileupload fileSPace"
                          }
                        >
                          <div className="upload">
                            {images === null ? (
                              <>
                                <img
                                  src={fileplus}
                                  alt="test"
                                  className="menu_icon"
                                />
                                <h3 className="mb-3">Add Form</h3>

                                <input
                                  className="position-absolute"
                                  type="file"
                                  id="fileInput"
                                  ref={refs}
                                  onChange={(e) => {
                                    onImagesChange(e);
                                  }}
                                  style={{ visibility: "hidden" }}
                                />
                                <p className="mb-4 adds-sub-text">
                                  Choose from an existing template or create new
                                  forms directly within Avenu .{" "}
                                </p>
                              </>
                            ) : isImage ? (
                              <img
                                src={images}
                                style={{ height: "30%", width: "30%" }}
                              />
                            ) : (
                              <video
                                src={images}
                                alt="test"
                                className="mb-2"
                                style={{ height: "30%", width: "30%" }}
                                controls
                              />
                            )}
                            <div className="upload-btns">
                              <button
                                className="up-btn btn"
                                onClick={() => {
                                  setIsNewSection(true);
                                  handleFocus();
                                  setShowOnboardingTemplates(true);
                                }}
                              >
                                Choose Form
                              </button>
                              <span className=" mx-4 or-text">or</span>
                              <a
                                className="createa form"
                                onClick={() => {
                                  handleFocus();
                                  sectionName !== ""
                                    ? navigate(
                                        "/dashboard/onboarding/create-onboarding-template-form",
                                        {
                                          state: {
                                            sectionname: sectionName,
                                            sectionSubtitle: sectionSubtitle,
                                          },
                                        }
                                      )
                                    : navigate(
                                        "/dashboard/onboarding/create-onboarding-template-form",
                                        {
                                          state: {
                                            sectionname: "New Section",
                                          },
                                        }
                                      );
                                }}
                              >
                                Create New Form
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="wraper mt-2">
                        <div className="action-itms-forms-main formInner b-0 wraper">
                          <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="section" type="section">
                              {(provided) => (
                                <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {sections.map((item, index) => {
                                    return (
                                      <Draggable
                                        key={item?.id}
                                        draggableId={item?.id.toString()}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            className="form-features newone"
                                            {...provided.draggableProps}
                                            ref={provided.innerRef}
                                            {...provided.dragHandleProps}
                                          >
                                            <Droppable
                                              droppableId={item?.id.toString()}
                                              type="form"
                                            >
                                              {(provided) => (
                                                <div
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  <div className="form-features newone">
                                                    <div className="bxborder wraper newPads_editform">
                                                      <h6 className="form-hd d-flex justify-content-between mb-4 formAlg-new align-items-center">
                                                        <div className="inpSpace">
                                                          <img
                                                            src={sdot}
                                                            alt="test"
                                                            className="dragBtn-fist mrR"
                                                          />
                                                          <div className="inpAlig">
                                                            <input
                                                              className="subHead_inp main-title titile-head-width"
                                                              type="text"
                                                              placeholder="Enter Sectionname"
                                                              onFocus={() => {
                                                                setIndex(index);
                                                                setRename(
                                                                  item?.section_name
                                                                );
                                                              }}
                                                              value={
                                                                indx === index
                                                                  ? rename
                                                                  : item?.section_name
                                                              }
                                                              onChange={(e) => {
                                                                setRename(
                                                                  e.target.value
                                                                );
                                                              }}
                                                              onKeyDown={(
                                                                e
                                                              ) => {
                                                                renameSection(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                              onBlur={(e) => {
                                                                renameSectionBlur(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                            />
                                                            <input
                                                              className="subHead_inp titile-head-width"
                                                              type="text "
                                                              placeholder="Enter Subtitle"
                                                              onClick={() => {
                                                                setIndx(index);
                                                                setRenameSubtitle(
                                                                  item?.subtitle
                                                                );
                                                              }}
                                                              value={
                                                                inx === index
                                                                  ? renameSubtitle
                                                                  : item?.subtitle
                                                              }
                                                              onChange={(e) => {
                                                                setRenameSubtitle(
                                                                  e.target.value
                                                                );
                                                              }}
                                                              onKeyDown={(
                                                                e
                                                              ) => {
                                                                renameSectionSubtitle(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                              onBlur={(e) => {
                                                                renameSectionSubtitleBlur(
                                                                  e,
                                                                  item?.id
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        </div>
                                                        <div className="btnSpace">
                                                          {/* {indx !== null || inx !== null ? <button className='head-close border-0 ms-5 clsBt' onClick={() => {
                                            setRename('')
                                            setIndex(null);
                                            setIndx(null);
                                            setRenameSubtitle('');
                                          }}><img src={close} alt="test" className="menu_icon" /></button> : */}
                                                          <button
                                                            className="head-close border-0 ms-5 clsBt"
                                                            onClick={() => {
                                                              setModalDatas({
                                                                item: "Section",
                                                                itemId:
                                                                  item?.id,
                                                                itemName:
                                                                  item?.section_name,
                                                              });
                                                              openModal();
                                                            }}
                                                          >
                                                            <img
                                                              src={trash}
                                                              alt="test"
                                                              className="menu_icon"
                                                            />
                                                          </button>
                                                        </div>
                                                      </h6>
                                                      <div className="f-group">
                                                        {item?.section_forms?.map(
                                                          (data, ind) => {
                                                            return (
                                                              <Draggable
                                                                key={data.id}
                                                                draggableId={data.id.toString()}
                                                                index={ind}
                                                              >
                                                                {(
                                                                  provided,
                                                                  snapshot
                                                                ) => (
                                                                  <div
                                                                    id={
                                                                      "formitem" +
                                                                      data?.id
                                                                    }
                                                                    className="f-itm newOne bor_drag"
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                    ref={
                                                                      provided.innerRef
                                                                    }
                                                                  >
                                                                    <div className="leftDivs">
                                                                      <button className="btn dragBtn">
                                                                        <img
                                                                          src={
                                                                            sdot
                                                                          }
                                                                          alt="test"
                                                                          className="menu_icon"
                                                                        />
                                                                      </button>
                                                                      <span className="form-name-edit">
                                                                        {/* <img src={star} alt="test" className="menu_icon" />  */}

                                                                        {/* <img src={video} alt="test" className="menu_icon" /> */}
                                                                        {
                                                                          data.title
                                                                        }
                                                                        {data
                                                                          ?.fields[0]
                                                                          ?.field_type_id ===
                                                                          13 && (
                                                                          <img
                                                                            src={
                                                                              filetext
                                                                            }
                                                                            alt="test"
                                                                            className="filetext-img "
                                                                          />
                                                                        )}
                                                                      </span>
                                                                    </div>
                                                                    <div className="d-flex">
                                                                      <div className="f-btns ediBtns">
                                                                        {data?.template_type ===
                                                                          "i-9form" ||
                                                                        data?.template_type ===
                                                                          "w4-form" ||
                                                                        data?.template_type ===
                                                                          "W4Sc-form" ||
                                                                        data?.template_type ===
                                                                          "direct-deposit" ||
                                                                        data?.template_type ===
                                                                          "Ohio-it4-combined" ||
                                                                        data?.subtitle ===
                                                                          "adminI9Pdf" ||
                                                                        data?.template_type ===
                                                                          "MI-W4_Form" ||
                                                                        data?.template_type ===
                                                                          "AR4EC-pdf" ||
                                                                        data?.template_type ===
                                                                          "L4-pdf" ? (
                                                                          <div></div>
                                                                        ) : (
                                                                          <button
                                                                            className="btn"
                                                                            onClick={() => {
                                                                              editNavigateFunction(
                                                                                data,
                                                                                item
                                                                              );
                                                                            }}
                                                                          >
                                                                            <div class="tooltip">
                                                                              <img
                                                                                src={
                                                                                  edit
                                                                                }
                                                                                alt="test"
                                                                                className="menu_icon bfBtn"
                                                                              />
                                                                              <img
                                                                                src={
                                                                                  editA
                                                                                }
                                                                                alt="test"
                                                                                className="menu_icon Actbtn"
                                                                              />
                                                                              <span class="tooltiptext edit-tip">
                                                                                Edit
                                                                              </span>
                                                                            </div>
                                                                          </button>
                                                                        )}
                                                                        {data?.template_type ===
                                                                          "i-9form" ||
                                                                        data?.template_type ===
                                                                          "w4-form" ||
                                                                        data?.subtitle ===
                                                                          "adminI9Pdf" ||
                                                                        data?.template_type ===
                                                                          "direct-deposit" ||
                                                                        data?.template_type ===
                                                                          "Ohio-it4-combined" ||
                                                                        data?.template_type ===
                                                                          "W4Sc-form" ||
                                                                        data?.template_type ===
                                                                          "MI-W4_Form" ||
                                                                        data?.template_type ===
                                                                          "AR4EC-pdf" ||
                                                                        data?.template_type ===
                                                                          "L4-pdf" ? (
                                                                          <></>
                                                                        ) : (
                                                                          <span
                                                                            style={{
                                                                              color:
                                                                                "rgb(102 102 102 / 29%)",
                                                                            }}
                                                                          >
                                                                            &nbsp;|&nbsp;
                                                                          </span>
                                                                        )}
                                                                      </div>

                                                                      <div className="f-btns deletBtns">
                                                                        <button
                                                                          className="btn"
                                                                          onClick={() => {
                                                                            setModalDatas(
                                                                              {
                                                                                item: "Form",
                                                                                itemId:
                                                                                  data.id,
                                                                                itemName:
                                                                                  data.title,
                                                                              }
                                                                            );
                                                                            openModal();
                                                                          }}
                                                                        >
                                                                          <div class="tooltip">
                                                                            <img
                                                                              src={
                                                                                trash
                                                                              }
                                                                              alt="test"
                                                                              className="menu_icon bfsBtn"
                                                                            />
                                                                            <svg
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              width="20"
                                                                              height="18"
                                                                              viewBox="0 0 20 22"
                                                                              fill="none"
                                                                              className="menu_icon Actsbtn"
                                                                            >
                                                                              <path
                                                                                d="M1 5H3H19"
                                                                                stroke="#3A68D8"
                                                                                stroke-width="2"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round"
                                                                              />
                                                                              <path
                                                                                d="M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5"
                                                                                stroke="#3A68D8"
                                                                                stroke-width="2"
                                                                                stroke-linecap="round"
                                                                                stroke-linejoin="round"
                                                                              />
                                                                            </svg>
                                                                            <span class="tooltiptext edit-tip">
                                                                              Delete
                                                                            </span>
                                                                          </div>
                                                                        </button>
                                                                        {/* <button className='btn'><img src={sdot} alt="test" className="menu_icon" /></button> */}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                )}
                                                              </Draggable>
                                                            );
                                                          }
                                                        )}
                                                      </div>

                                                      <div className="choose-files d-flex justify-content-center wraper mt-4 mb-0">
                                                        <div className="upload-btns d-flex align-items-center">
                                                          <button
                                                            onClick={() => {
                                                              setIsNewSection(
                                                                false
                                                              );
                                                              setShowOnboardingTemplates(
                                                                true
                                                              );
                                                              setSectionId(
                                                                item?.id
                                                              );
                                                            }}
                                                            className="up-btn btn mr-0 choose-text"
                                                          >
                                                            Choose Form
                                                          </button>
                                                          <h6 className="mx-4 or-text">
                                                            or
                                                          </h6>
                                                          <a
                                                            onClick={() => {
                                                              navigate(
                                                                "/dashboard/onboarding/create-form",
                                                                {
                                                                  state: {
                                                                    item: item,
                                                                  },
                                                                }
                                                              );
                                                            }}
                                                            className="createa form"
                                                          >
                                                            Create New Form
                                                          </a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </Droppable>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        </div>
                      </div>

                      {addSection === true && (
                        <div
                          className="form-features mt-4 formInner formWarp p-0 wraper"
                          id="section"
                        >
                          <h6 className="form-hd d-flex justify-content-between formAlg-new align-items-center">
                            <div className="inpSpace">
                              <img
                                src={sdot}
                                alt="test"
                                className="menu_icon"
                              />
                              <div className="inpAlig">
                                <input
                                  className="subHead_inp main-title titile-head-width"
                                  ref={inputRef}
                                  type="text"
                                  placeholder="New Section"
                                  value={sectionName}
                                  onFocus={handleFocus}
                                  onChange={(e) => {
                                    setSectionName(e.target.value);
                                  }}
                                  onKeyDown={addNewSection}
                                  onBlur={() => {
                                    (sectionName !== "" ||
                                      sectionSubtitle !== "") &&
                                      addNewSectionBlur();
                                  }}
                                />
                                {/* <p className='subtits'>gfsagsa</p> */}
                                <input
                                  className="subHead_inp titile-head-width"
                                  type="text"
                                  placeholder="Enter Subtitle"
                                  value={sectionSubtitle}
                                  onFocus={handleFocus}
                                  onChange={(e) => {
                                    setSectionSubtitle(e.target.value);
                                  }}
                                  onKeyDown={addNewSection}
                                  onBlur={inputBlur}
                                />
                              </div>
                            </div>
                            <div className="btnSpace">
                              <button
                                className="head-close border-0 clsBt ms-5"
                                onClick={() => {
                                  setSectionName("");
                                  setSectionSubtitle("");
                                  setAddSection(false);
                                }}
                              >
                                {" "}
                                <img
                                  src={close}
                                  alt="test"
                                  className="menu_icon"
                                />{" "}
                              </button>
                            </div>
                          </h6>

                          <div
                            className={
                              sizeExceed
                                ? "fileuploadExceed"
                                : "fileupload fileSPace"
                            }
                          >
                            <div className="upload">
                              {images === null ? (
                                <>
                                  <img
                                    src={fileplus}
                                    alt="test"
                                    className="menu_icon"
                                  />
                                  <h3 className="mb-3">Add Form</h3>

                                  <input
                                    className="position-absolute"
                                    type="file"
                                    id="fileInput"
                                    ref={refs}
                                    onChange={(e) => {
                                      onImagesChange(e);
                                    }}
                                    style={{ visibility: "hidden" }}
                                  />
                                  <p className="mb-4 adds-sub-text">
                                    Choose from an existing template or create
                                    new forms directly within Avenu .{" "}
                                  </p>
                                </>
                              ) : isImage ? (
                                <img
                                  src={images}
                                  style={{ height: "30%", width: "30%" }}
                                />
                              ) : (
                                <video
                                  src={images}
                                  alt="test"
                                  className="mb-2"
                                  style={{ height: "30%", width: "30%" }}
                                  controls
                                />
                              )}
                              <div className="upload-btns">
                                <button
                                  className="up-btn btn"
                                  onClick={() => {
                                    setIsNewSection(true);
                                    handleFocus();
                                    setShowOnboardingTemplates(true);
                                  }}
                                >
                                  Choose Form
                                </button>
                                <span className=" mx-4 or-text">or</span>
                                <a
                                  className="createa form"
                                  onClick={() => {
                                    handleFocus();
                                    sectionName !== ""
                                      ? navigate(
                                          "/dashboard/onboarding/create-form",
                                          {
                                            state: {
                                              sectionname: sectionName,
                                              sectionSubtitle: sectionSubtitle,
                                            },
                                          }
                                        )
                                      : navigate(
                                          "/dashboard/onboarding/create-form",
                                          {
                                            state: {
                                              sectionname: "New Section",
                                            },
                                          }
                                        );
                                  }}
                                >
                                  Create New Form
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )
                ) : (
                  <div
                    className="form-features mt-4 formInner formWarp p-0 wraper"
                    id="section"
                  >
                    <h6 className="form-hd d-flex justify-content-between formAlg-new align-items-center">
                      <div className="inpSpace">
                        <img src={sdot} alt="test" className="menu_icon" />
                        <div className="inpAlig">
                          <input
                            className="subHead_inp main-title titile-head-width"
                            ref={inputRef}
                            type="text"
                            placeholder="New Section"
                            value={sectionName}
                            onFocus={() => {
                              !isNew && handleFocus();
                            }}
                            onChange={(e) => {
                              !isNew && setSectionName(e.target.value);
                            }}
                            onKeyDown={() => {
                              !isNew && addNewSection();
                            }}
                            onBlur={() => {
                              !isNew &&
                                (sectionName !== "" ||
                                  sectionSubtitle !== "") &&
                                addNewSectionBlur();
                            }}
                            disabled={isNew}
                          />
                          {/* <p className='subtits'>gfsagsa</p> */}
                          <input
                            className="subHead_inp titile-head-width"
                            type="text"
                            placeholder="Enter Subtitle"
                            value={sectionSubtitle}
                            onFocus={() => {
                              !isNew && handleFocus();
                            }}
                            onChange={(e) => {
                              !isNew && setSectionSubtitle(e.target.value);
                            }}
                            onKeyDown={() => {
                              !isNew && addNewSection();
                            }}
                            onBlur={() => {
                              !isNew && inputBlur();
                            }}
                            disabled={isNew}
                          />
                        </div>
                      </div>
                      <div className="btnSpace">
                        <button
                          className="head-close border-0 clsBt ms-5"
                          onClick={() => {
                            !isNew && setSectionName("");
                            setSectionSubtitle("");
                            setAddSection(false);
                          }}
                          disabled={isNew}
                        >
                          {" "}
                          <img
                            src={close}
                            alt="test"
                            className="menu_icon"
                          />{" "}
                        </button>
                      </div>
                    </h6>

                    <div
                      className={
                        sizeExceed ? "fileuploadExceed" : "fileupload fileSPace"
                      }
                      style={{ border: isNew && "2px dashed #dfdfdf" }}
                    >
                      <div className="upload">
                        {images === null ? (
                          <>
                            <img
                              src={fileplus}
                              alt="test"
                              className="menu_icon"
                            />
                            <h3
                              className="mb-3"
                              style={{
                                color: isNew && "rgb(102 102 102 / 65%)",
                              }}
                            >
                              Add Form
                            </h3>

                            <input
                              className="position-absolute"
                              type="file"
                              id="fileInput"
                              ref={refs}
                              onChange={(e) => {
                                onImagesChange(e);
                              }}
                              style={{ visibility: "hidden" }}
                            />
                            <p className="mb-4 adds-sub-text">
                              Choose from an existing template or create new
                              forms directly within Avenu .{" "}
                            </p>
                          </>
                        ) : isImage ? (
                          <img
                            src={images}
                            style={{ height: "30%", width: "30%" }}
                          />
                        ) : (
                          <video
                            src={images}
                            alt="test"
                            className="mb-2"
                            style={{ height: "30%", width: "30%" }}
                            controls
                          />
                        )}
                        <div className="upload-btns">
                          <button
                            disabled={isNew}
                            className="up-btn btn"
                            onClick={() => {
                              !isNew && setIsNewSection(true);
                              handleFocus();
                              setShowOnboardingTemplates(true);
                            }}
                          >
                            Choose Form
                          </button>
                          <span className=" mx-4 or-text">or</span>
                          <a
                            disabled={isNew}
                            className="createa form"
                            onClick={() => {
                              handleFocus();
                              if (isEdit === true) {
                                sectionName !== ""
                                  ? navigate(
                                      "/dashboard/onboarding/create-onboarding-template-form",
                                      {
                                        state: {
                                          sectionname: sectionName,
                                          sectionSubtitle: sectionSubtitle,
                                        },
                                      }
                                    )
                                  : navigate(
                                      "/dashboard/onboarding/create-onboarding-template-form",
                                      {
                                        state: {
                                          sectionname: "New Section",
                                        },
                                      }
                                    );
                              } else {
                                sectionName !== ""
                                  ? navigate(
                                      "/dashboard/onboarding/create-form",
                                      {
                                        state: {
                                          sectionname: sectionName,
                                          sectionSubtitle: sectionSubtitle,
                                        },
                                      }
                                    )
                                  : navigate(
                                      "/dashboard/onboarding/create-form",
                                      {
                                        state: {
                                          sectionname: "New Section",
                                        },
                                      }
                                    );
                              }
                            }}
                          >
                            Create New Form
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="container-fluid row h-100">
                <div className="col-md-12">
                  {/* <div className='create-sec onb-actions mb-3'>
                  <a href='#' className='btn' onClick={() => setIsCreateFormOpen(true)}><img src={add} alt="test" className="menu_icon" /> Create Form</a>
                  <a className='btn' onClick={() => { console.log("Clicked"); handleClickScroll(); }} ><img src={add} alt="test" className="menu_icon" /> Add Section</a>
                </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 setupRightDiv" id="scrollDiv">
            {/* <div className='secBox px-4 py-3 mb-4 m-3 mt-0'>
            <div className='grp-hd flex-column d-flex align-items-start'>
              <h6 className='d-flex justify-content-between w-100' >Navigator <img src={Infos} alt="test" className="menu_icon" /></h6>
              <ul className='grp-listing navigations mt-3 h-100' >
                <li className='create-G p-0' >

                  <div className="accordion" id="accordionExample"> */}
            {/* {sections.map((item, index) => {
                      return ( */}
            {/* <div className="accordion-item mb-3">
                          <h2 className="accordion-header" id="heading">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${index}`} aria-expanded="true" aria-controls={`collapse${index}`}>
                              <h6>{item?.section_name}</h6>
                            </button>
                          </h2> */}
            {/* <div id={`collapse${index}`} className="accordion-collapse collapse show" aria-labelledby="heading" data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                              <ul className='py-3 listing-lists' > */}
            {/* {item?.section_forms?.map((data) => {
                                  return (
                                    <li onClick={() => { handleScroll(data.id) }}><a>{data.title}</a> </li>
                                  )
                                })} */}
            {/* <li><a href='#'>Introductory Video</a> </li>
                                <li><a href='#' className='active' >Tell us about yourself</a> </li>
                                <li><a href='#'>Employee Agreement</a> </li> */}
            {/* </ul>
                            </div>
                          </div>
                        </div> */}
            {/* )
                    })} */}
            {/* </div>

                </li>
              </ul>
            </div>
          </div> */}
            <div className="edit-right-fixes">
              <div className="secBox px-4 py-3 mb-4 my-3 mt-0 ">
                <div className="grp-hd flex-column d-flex align-items-start">
                  <h6 className="d-flex justify-content-between w-100 form_subTitles righTitles">
                    Deadline
                    <div class="tooltip">
                      <img src={Infos} alt="test" className="menu_icon" />
                      <span class="tooltiptext">
                        Set a time limit for employees to finish their
                        onboarding.
                      </span>
                    </div>
                  </h6>
                  <ul className="grp-listing navigations mt-2 h-100 tempList">
                    <li className="create-G p-0 d-flex flex-column align-items-start">
                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          ref={deadlineRef}
                          className="form-control"
                          id="signHereInput"
                          placeholder="Number of Days"
                          value={deadLine}
                          onKeyDown={(e) => {
                            setDeadlineOnEnter(e);
                          }}
                          onChange={(e) => {
                            setDeadLine(e.target.value);
                          }}
                          onBlur={() => {
                            setDeadline();
                          }}
                        />
                        <label htmlFor="signHereInput">
                          Deadline
                          <sup style={{ color: "red", fontSize: "13px" }}>
                            *
                          </sup>
                        </label>
                      </div>
                      {parseInt(deadLine) === 0 && (
                        <p style={{ color: "red" }}>
                          Deadline cannot be zero !
                        </p>
                      )}
                      {/* <label className='mb-0'>Deadline<sup style={{ color: 'red', fontSize: '13px' }}>*</sup></label>
                  <input className='form-control' placeholder='Number of Days' value={deadLine} onChange={(e) => { setDeadLine(e.target.value); console.log(e.target.value, deadLine) }}
                    onBlur={() => { setDeadline(); }} />
                  {parseInt(deadLine) === 0 && <p style={{ color: 'red' }}>Deadline cannot be zero !</p>} */}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="secBox px-4 py-3 mb-4 my-3 mt-0 ">
                <div className="grp-hd flex-column d-flex align-items-start">
                  <h6 className="d-flex justify-content-between w-100 form_subTitles righTitles">
                    OTP Verification
                    <div class="tooltip">
                      <img src={Infos} alt="test" className="menu_icon" />
                      <span class="tooltiptext">
                        Turning this on will require the candidate to verify
                        their phone number before onboarding.
                      </span>
                    </div>
                  </h6>
                  <ul className="grp-listing navigations mt-2 h-100 tempList">
                    <li className="create-G p-0 d-flex flex-column align-items-start">
                      <div className="form-floating mb-3">
                        <div className="reqDiv">
                          <label className="add-btn" style={{ cursor: "text" }}>
                            Send OTP Verification
                          </label>

                          {/* <div class="toggle-container mx-3">
  <input   type="checkbox"
                              checked={isVerify === true}
                              onChange={() => {
                                manageSendOtp();
                              }} id="toggle" class="toggle-input"/>
  <label for="toggle" class="toggle-label">
    <span class="toggle-circle"></span>
  </label>
</div>*/}
                          <label class="switch togSw ">
                            <input
                              type="checkbox"
                              checked={isVerify === true}
                              onChange={() => {
                                manageSendOtp();
                              }}
                            />
                            <span class="slider round"></span>
                          </label>
                        </div>
                      </div>
                      {/* <label className='mb-0'>Deadline<sup style={{ color: 'red', fontSize: '13px' }}>*</sup></label>
                  <input className='form-control' placeholder='Number of Days' value={deadLine} onChange={(e) => { setDeadLine(e.target.value); console.log(e.target.value, deadLine) }}
                    onBlur={() => { setDeadline(); }} />
                  {parseInt(deadLine) === 0 && <p style={{ color: 'red' }}>Deadline cannot be zero !</p>} */}
                    </li>
                  </ul>
                </div>
              </div>

              {!isEdit && (
                <div className="secBox px-4 py-3 mb-4 my-3 mt-0">
                  <div className="grp-hd flex-column d-flex align-items-start">
                    <h6 className="d-flex justify-content-between w-100 form_subTitles righTitles">
                      Templates
                      <div class="tooltip">
                        <img src={Infos} alt="test" className="menu_icon" />
                        <span class="tooltiptext">
                          Select or save an onboarding template of pre-designed
                          forms and documents.
                        </span>
                      </div>
                    </h6>
                    <ul className="grp-listing navigations mt-2 h-100 tempList">
                      <li className="create-G d-flex flex-column align-items-start">
                        <a
                          className="add-btn"
                          onClick={() => {
                            fetchSectionTemplates();
                            setIsImportSectionTemplateOpen(true);
                          }}
                        >
                          <img src={imp} alt="test" className="hd_icon-e" />
                          Choose Onboarding Template
                        </a>
                      </li>
                      <li className="create-G d-flex flex-column align-items-start ">
                        {/* <a className='add-btn save-temp' onClick={() => { setIsSaveSectionTemplateOpen(true) }}><img src={save} alt="test" className="hd_icon-e" />Save Template</a> */}
                        <a
                          className="add-btn "
                          onClick={() => {
                            setIsSaveSectionTemplateOpen(true);
                          }}
                        >
                          <img src={saves} alt="test" className="add-btn" />
                          Save Template
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

              <div className="secBox px-4 py-3 mb-4 my-3 mt-0">
                <div className="grp-hd flex-column d-flex align-items-start">
                  <h6 className="d-flex justify-content-between w-100 form_subTitles righTitles">
                    Create
                    <div class="tooltip">
                      <img src={Infos} alt="test" className="menu_icon" />
                      <span class="tooltiptext">
                        Add a new section of forms and documents
                      </span>
                    </div>
                  </h6>
                  <ul className="grp-listing navigations mt-2 h-100 tempList">
                    <li className="create-G p-0 d-flex flex-column align-items-start">
                      <a
                        className="add-btn"
                        onClick={() => {
                          console.log("Clicked");
                          setAddSection(true);
                          handleClickScroll();
                        }}
                      >
                        <img
                          src={addsP}
                          alt="test"
                          className="menu_icon me-3 text-dark"
                        />
                        Add Section
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className='secBox px-4 py-3 mb-4 my-3 mt-0'>
            <div className='grp-hd flex-column d-flex align-items-start'>

              <ul className='grp-listing navigations mt-3 h-100' >
                <li className='create-G p-0 d-flex flex-column align-items-center'>
                  <a href='#' className='d-flex justify-content-center text-dark'><img src={Helps} alt="copy" className="create-icon mb-0 me-2" />Need Help</a>
                </li>
              </ul>
            </div>
          </div> */}
          </div>
        </div>
      ) : null}

      <Modal isOpen={isCreateFormOpen}>
        <div>
          <div className="modal-header">
            <h5 className="modal-title">Create New Form</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setIsCreateFormOpen(false);
              }}
            ></button>
          </div>

          <div className="modal-body">
            <div className="form-check mt-4 mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
              />
              <label className="form-check-label" for="flexRadioDefault1">
                Mark as required
              </label>
            </div>

            <label className="form-label">Description:</label>
            <div className="rich-text">
              <img src={Rich} alt="test" className="menu_icon" />
            </div>

            <label className="form-label mt-4 mb-3">Add Media: </label>
            <div
              className="select"
              onChange={(e) => alterPopups(e.target.value)}
            >
              <select className="form-control w-25">
                <option selected value="">
                  Upload{" "}
                </option>
                <option value="Media">Media</option>
                <option value="Existing Form">Existing Form</option>
              </select>
            </div>
            <div className="btn-groups mt-4 mb-3">
              <button class="status-btn">Form Field</button>
              <button class="status-btn">Multiple Choice</button>
              <button class="status-btn">eSignature</button>
            </div>
            <label className="form-label">Form Section </label>
            <div className="select">
              <select className="form-control w-25">
                {sections?.map((item) => {
                  return (
                    <option value={item?.section_forms}>
                      {item?.section_name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary save-pop">
              Save
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={isUploadOpen}>
        <div>
          <div className="modal-header">
            <h5 className="modal-title">Upload New Media</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setIsUploadOpen(false);
                setModalState(null);
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div
              className="vdo mt-4 mb-3 "
              onClick={() => {
                ref.current.click();
              }}
            >
              {modalState === null && (
                <img
                  src={image === null ? Upload : image}
                  alt="test"
                  className="video-thumb"
                />
              )}
              {modalState !== null &&
                modalState?.fields?.[0]?.field_type_id === 3 && (
                  <img
                    src={API.mediaView + modalState.fields[0].file_path}
                    alt="test"
                    className="video-thumb"
                  />
                )}
              {modalState !== null &&
                modalState?.fields?.[0]?.field_type_id === 4 && (
                  <video
                    src={API.mediaView + modalState.fields[0].file_path}
                    alt="test"
                    className="video-thumb"
                    controls
                  />
                )}
              {/*<img src={Videoplay} alt="test" className="play-btn" />*/}
            </div>
            <input
              type="file"
              ref={ref}
              onChange={(e) => {
                onImageChange(e);
              }}
              style={{ visibility: "hidden" }}
            />
            <div className="select">
              <select
                className="form-control w-25"
                onChange={(e) => alterPopups(e.target.value)}
              >
                <option selected>Upload </option>
                <option>Media</option>
                <option>Existing Form</option>
              </select>
            </div>

            <div className="form-check mt-4 mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                onChange={() => {
                  setIsRequired(!isRequired);
                }}
                checked={isRequired ? "checked" : ""}
              />
              <label className="form-check-label" for="flexRadioDefault1">
                Mark as required
              </label>
            </div>

            <label className="form-label mt-4 mb-3">Media Type: </label>
            <div className="form-check mt-2 mb-3">
              <input
                className="form-check-input"
                type="radio"
                name="mediatype"
                value="3"
                onChange={(e) => {
                  setMediaType(e.target.value);
                }}
                checked={mediaType === 3 ? "checked" : ""}
              />
              <label className="form-check-label" for="flexRadioDefault1">
                Image
              </label>
            </div>
            <div className="form-check mt-2 mb-3">
              <input
                className="form-check-input ml-2"
                type="radio"
                name="mediatype"
                value="4"
                onChange={(e) => {
                  setMediaType(e.target.value);
                }}
                checked={mediaType === 4 ? "checked" : ""}
              />
              <label className="form-check-label" for="flexRadioDefault1">
                Video
              </label>
            </div>

            <div className="textarea mt-4 mb-3">
              <label>Description:</label>
              <textarea
                className="form-control"
                placeholder="This is a sample description...."
                value={title}
                rows={2}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              ></textarea>
            </div>
            {modalState === null && (
              <label className="form-label">Form Section </label>
            )}
            {modalState === null && (
              <div className="select">
                <select
                  className="form-control w-25"
                  onChange={(e) => {
                    setSectionName(e.target.value);
                  }}
                >
                  {sections?.map((item) => {
                    return (
                      <option value={item?.section_forms}>
                        {item?.section_name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}
          </div>
          {modalState === null && (
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary save-pop"
                onClick={() => {
                  uploadMedia();
                }}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </Modal>

      <Modal isOpen={isSaveSectionTemplateOpen}>
        <div>
          <div className="modal-header">
            <h5 className="modal-title">Save Onboarding Template</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                isNew ? navigate(-1) : setIsSaveSectionTemplateOpen(false);
              }}
            ></button>
          </div>
          <div className="modal-body " style={{ marginTop: "-12px" }}>
            <label className="form-label  mb-2">
              Onboarding Template Name:{" "}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Template Name"
              onChange={(e) => {
                setTemplateName(e.target.value);
              }}
            ></input>
          </div>
          <div className="modal-footer footer-marg">
            <button
              type="button"
              className="btn btn-primary Cancel-pop"
              onClick={() => {
                isNew ? navigate(-1) : setIsSaveSectionTemplateOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary Add-pop mx-3"
              onClick={() => {
                isNew ? saveSectionTemplate() : saveTemplate();
              }}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={isImportSectionTemplateOpen} className="tem-hide-dives">
        <div>
          <div className="modal-header mb-1">
            <h5 className="modal-title">Choose Onboarding Template</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setIsImportSectionTemplateOpen(false);
                setSearchKey("");
              }}
            ></button>
          </div>
          <div className="create-comp-modal-body px-3 mb-2">
            <div className="serchField space m-0 col-lg-5">
              <img src={searchsmall} alt="test" className="serc_icon" />
              <input
                type="text"
                className="sercInp"
                placeholder="Search File Library..."
                onChange={(e) => {
                  setSearchKey(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="detail-tab-edit temp-space wraper m-0 p-3 pt-0 pb-0">
            {/* <Tabs>
              <TabList>
                <Tab>Forms</Tab>
                {/* <Tab>Documents</Tab> */}
            {/* </TabList>
          <div className="create-comp-under-line"></div>
          <TabPanel>  */}
            <div className="create-comp-scroll m-0 scrlHe-tab scroll scroll1">
              {sectionTemplates.length === 0 ? (
                <div className="col-lg-12 topnav-tab">
                  <a className="create-comp-popup-text-not-found">
                    <h6 className="create-comp-popup-text-heading-not-found">
                      No templates found
                    </h6>
                  </a>
                </div>
              ) : (
                sectionTemplates.map((item) => {
                  return (
                    <div className="col-lg-12 topnav-tab">
                      <a
                        className={
                          templateId === item?.id
                            ? "active create-comp-popup-text"
                            : "create-comp-popup-text"
                        }
                        onClick={() => {
                          setTemplateChatbotId(item?.chatbot_id);
                          setTemplateId(item?.id);
                        }}
                      >
                        <h6 className="create-comp-popup-text-heading">
                          {item?.template_name}
                        </h6>
                        <span
                          class="icon-trash"
                          onClick={() => {
                            setSectionModalData({
                              itemId: item?.id,
                              itemName: item?.template_name,
                            });
                            setSectionDeleteModal(true);
                          }}
                        >
                          <img
                            src={trash}
                            alt="trash"
                            className="trash-choos-temp-icon-popups"
                          />
                        </span>
                      </a>
                    </div>
                  );
                })
              )}
              {/* <div className='col-lg-12 topnav-tab'>
                                              <a href='#' className='active create-comp-popup-text' >
                                                <h6 className='create-comp-popup-text-heading'>Forms</h6>
                                              </a>
                                          </div>

                                          <div className='col-lg-12'>
                                              <a href='#' className='create-comp-popup-text' >
                                                <h6 className='create-comp-popup-text-heading '>Forms</h6>
                                              </a>
                                          </div>

                                          <div className='col-lg-12'>
                                              <a href='#' className='create-comp-popup-text' >
                                                <h6 className='create-comp-popup-text-heading'>Forms</h6>
                                              </a>
                                          </div>

                                          <div className='col-lg-12'>
                                              <a href='#' className='create-comp-popup-text' >
                                                <h6 className='create-comp-popup-text-heading'>Forms</h6>
                                              </a>
                                          </div> */}
            </div>
            {/* </TabPanel> */}

            {/* <TabPanel>
                <div className='col-lg-12 topnav-tab'>
                  <a href='#' className='active create-comp-popup-text' >
                    <h6 className='create-comp-popup-text-heading'>Forms</h6>
                  </a>
                </div>

                <div className='col-lg-12'>
                  <a href='#' className='create-comp-popup-text' >
                    <h6 className='create-comp-popup-text-heading'>Documents</h6>
                  </a>
                </div>

                <div className='col-lg-12'>
                  <a href='#' className='create-comp-popup-text' >
                    <h6 className='create-comp-popup-text-heading'>Documents</h6>
                  </a>
                </div>

                <div className='col-lg-12'>
                  <a href='#' className='create-comp-popup-text' >
                    <h6 className='create-comp-popup-text-heading'>Documents</h6>
                  </a>
                </div>
              </TabPanel> */}
            {/* </Tabs> */}
          </div>

          {/*<div className='row common-r mt-4 scroll-y'>
              {sectionTemplates.map((item) => {
                return (
                  <div className='col-lg-12'>
                    <a className={templateId === item?.id ? 'create-comp active' : 'create-comp'} onClick={() => {
                      setTemplateChatbotId(item?.chatbot_id)
                      setTemplateId(item?.id)
                    }}>
                      <h6 className='pop-tab-text'>{item?.template_name}</h6>
                    </a>
                  </div>
                )
              })}
              </div>*/}

          {/* <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div>
              <div className='col-lg-4'>
                <a href='#' className='create-comp' >
                  <h6>Template1</h6>
                </a>
              </div> */}

          <div className="modal-footer footer-marg mt-0">
            <button
              type="button"
              className="btn btn-primary Cancel-pop"
              onClick={() => {
                setIsImportSectionTemplateOpen(false);
                setSearchKey("");
                setTemplateId(null);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary Add-pop mx-3"
              onClick={() => {
                importTemplate();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>

      <div className="grid h-screen place-items-center ">
        {/* <button onClick={openModal} className="bg-white px-4 py-3 rounded border-2 shadow-md shadow-red-600 hover:bg-gray-200">Open Modal</button> */}

        <Modal
          isOpen={sectionDeleteModal}
          onRequestClose={() => {
            setSectionDeleteModal(false);
          }}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width dltPops">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Delete Template
            </h2>

            <button
              onClick={() => {
                setSectionDeleteModal(false);
              }}
              className="modal-close"
            >
              {" "}
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts pb-0">
              Are you sure you want to delete {sectionModalData?.itemName}{" "}
              template?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  deleteSectionTemplate(sectionModalData.itemId);
                }}
              >
                {" "}
                Yes{" "}
              </button>
              <p
                className="cancel-bttn"
                onClick={() => {
                  setSectionDeleteModal(false);
                }}
              >
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>

      <Modal isOpen={showOnboardingTemplates}>
        <div>
          <div className="modal-header mb-0">
            <h5 className="modal-title text-choose-margn">Choose File</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowOnboardingTemplates(false);
                setSearchKey("");
              }}
            ></button>
          </div>

          <div className="modal-body ">
            <div className="serchField mb-3 col-lg-5">
              <img src={searchsmall} alt="test" className="serc_icon" />
              <input
                type="text"
                className="sercInp"
                placeholder="Search File Library..."
                onChange={(e) => {
                  setSearchKey(e.target.value);
                }}
              />
            </div>

            <div className="detail-tabs mt-3">
              <Tabs>
                <TabList>
                  <Tab style={{ margin: "0px 10px 0px 0px" }}>Forms</Tab>
                  <Tab style={{ margin: "0px 20px 0px 10px" }}>PDFs</Tab>
                  {/* <Tab>Files</Tab> */}
                  <Tab>Legal Forms</Tab>
                </TabList>
                {/*<div className="create-comp-under-line"></div>*/}
                <div className="under-line"></div>
                <TabPanel>
                  <div className=" wraper scrlHe-tab scroll scroll1 ">
                    {onboardingTemplates.length === 0 ? (
                      <div className="col-lg-12 topnav-tab">
                        <a className="create-comp-popup-text-not-found">
                          <h6 className="create-comp-popup-text-heading-not-found">
                            No templates found
                          </h6>
                        </a>
                      </div>
                    ) : (
                      onboardingTemplates?.map((item) => {
                        return (
                          <div className="col-lg-12 topnav-tab">
                            <a
                              className={
                                !isEdit && !isNew
                                  ? templateId === item?.id
                                    ? "active create-comp-popup-text"
                                    : "create-comp-popup-text"
                                  : "create-comp-popup-text"
                              }
                              onClick={() => {
                                setTemplateChatbotId(item?.chatbot_id);
                                setTemplateId(item?.id);
                                setType("template");
                              }}
                            >
                              {(isEdit || isNew) && (
                                <input
                                  type="checkbox"
                                  className="mx-2"
                                  onChange={() =>
                                    handleCheckboxChange(item?.id)
                                  }
                                  checked={idArray.includes(String(item?.id))}
                                />
                              )}
                              <h6 className="create-comp-popup-text-heading">
                                {item?.template_name !== null
                                  ? item?.template_name
                                  : item?.title}
                              </h6>
                              {/* <span class="icon-trash" >
                                    <img src={trash} alt="trash" className="trash-icon-popup" />
                                  </span> */}
                            </a>
                          </div>
                        );
                      })
                    )}
                  </div>
                </TabPanel>

                <TabPanel>
                  <div className="wraper scrlHe-tab scroll scroll1">
                    {convertedDocuments.length === 0 ? (
                      <div className="col-lg-12 topnav-tab">
                        <a className="create-comp-popup-text-not-found">
                          <h6 className="create-comp-popup-text-heading-not-found">
                            No templates found
                          </h6>
                        </a>
                      </div>
                    ) : (
                      convertedDocuments?.map((item) => {
                        return (
                          <div className="col-lg-12 topnav-tab ">
                            <a
                              className={
                                !isEdit && !isNew
                                  ? templateId === item?.id
                                    ? "active create-comp-popup-text"
                                    : "create-comp-popup-text"
                                  : "create-comp-popup-text"
                              }
                              onClick={() => {
                                setTemplateChatbotId(item?.chatbot_id);
                                setTemplateId(item?.id);
                                setType("document");
                              }}
                            >
                              {(isEdit || isNew) && (
                                <input
                                  type="checkbox"
                                  className="mx-2"
                                  onChange={() =>
                                    handleCheckboxChange(item?.id)
                                  }
                                  checked={idArray.includes(String(item?.id))}
                                />
                              )}
                              <h6 className="create-comp-popup-text-heading">
                                {item?.title}
                              </h6>
                              {/* <span class="icon-trash" >
                                    <img src={trash} alt="trash" className="trash-icon-popup" />
                                  </span> */}
                            </a>
                          </div>
                        );
                      })
                    )}
                  </div>{" "}
                </TabPanel>
                {/* <TabPanel>
                      <div className="wraper scrlHe-tab scroll scroll1">
                        {files.length === 0 ?
                          <div className='col-lg-12 topnav-tab'>
                            <a className='create-comp-popup-text-not-found' >
                              <h6 className='create-comp-popup-text-heading-not-found'>No templates found</h6>
                            </a>
                          </div>
                          : files?.map((item) => {
                            return (
                              <div className='col-lg-12 topnav-tab '>
                                <a className={templateId === item?.id ? 'active create-comp-popup-text' : 'create-comp-popup-text'} onClick={() => {
                                  setTemplateChatbotId(item?.chatbot_id)
                                  setTemplateId(item?.id)
                                  setType('document')
                                }}>
                                  <h6 className='create-comp-popup-text-heading'>{item?.title}</h6>
                                </a>
                              </div>
                            )
                          })}
                      </div>
                    </TabPanel> */}
                <TabPanel>
                  <div className="wraper scrlHe-tab scroll scroll1">
                    {legalForms.length === 0 ? (
                      <div className="col-lg-12 topnav-tab">
                        <a className="create-comp-popup-text-not-found">
                          <h6 className="create-comp-popup-text-heading-not-found">
                            No templates found
                          </h6>
                        </a>
                      </div>
                    ) : (
                      legalForms?.map((item) => {
                        return (
                          <div className="col-lg-12 topnav-tab ">
                            <a
                              className={
                                !isEdit && !isNew
                                  ? templateId === item?.id
                                    ? "active create-comp-popup-text"
                                    : "create-comp-popup-text"
                                  : "create-comp-popup-text"
                              }
                              onClick={() => {
                                setTemplateChatbotId(item?.chatbot_id);
                                setTemplateId(item?.id);
                                setType("template");
                              }}
                            >
                              {(isEdit || isNew) && (
                                <input
                                  type="checkbox"
                                  className="mx-2"
                                  onChange={() =>
                                    handleCheckboxChange(item?.id)
                                  }
                                  checked={idArray.includes(String(item?.id))}
                                />
                              )}
                              <h6 className="create-comp-popup-text-heading">
                                {item?.title}
                              </h6>
                            </a>
                          </div>
                        );
                      })
                    )}
                  </div>
                </TabPanel>
              </Tabs>
            </div>
            {/*<div className='row common-r mt-4 scroll-y'>
              {onboardingTemplates?.map((item) => {
                return (
                  <div className='col-lg-4'>
                    <a className={templateId === item?.id ? 'create-comp active' : 'create-comp'} onClick={() => {
                      setTemplateChatbotId(item?.chatbot_id)
                      setTemplateId(item?.id)
                      setType('template')
                    }}>
                      <h6 className='choosefrom pop-tab-text'>{item?.title}</h6>
                    </a>
                  </div>
                )
              })}

              {convertedDocuments?.map((item) => {
                return (
                  <div className='col-lg-4'>
                    <a className={templateId === item?.id ? 'create-comp active' : 'create-comp'} onClick={() => {
                      setTemplateChatbotId(item?.chatbot_id)
                      setTemplateId(item?.id)
                      setType('document')
                    }}>
                      <h6>{item?.title}</h6>
                    </a>
                  </div>
                )
              })}
            </div>*/}
          </div>
          <div className="modal-footer footer-marg mt-0 pt-3">
            <button
              type="button"
              className="btn btn-primary Cancel-pop"
              onClick={() => {
                setShowOnboardingTemplates(false);
                setSearchKey("");
                setTemplateId(null);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary Add-pop mx-3"
              onClick={() => {
                importTemplate();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>

      <div className="grid h-screen place-items-center ">
        {/* <button onClick={openModal} className="bg-white px-4 py-3 rounded border-2 shadow-md shadow-red-600 hover:bg-gray-200">Open Modal</button> */}

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width dltPops">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              {modalData?.item === "Section" ? "Delete Section" : "Delete Form"}
            </h2>

            <button onClick={closeModal} className="modal-close">
              {" "}
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts pb-0">
              Are you sure you want to delete {modalData?.itemName}?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              {modalData.item === "Section" ? (
                <button
                  className="yes-btn rounded p-2"
                  onClick={() => {
                    deleteSection(modalData.itemId);
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>
              ) : (
                <button
                  className="yes-btn rounded p-2"
                  onClick={() => {
                    deleteForm(modalData.itemId);
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>
              )}
              <p className="cancel-bttn" onClick={closeModal}>
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>
      <div className="grid h-screen place-items-center ">
        {/* <button onClick={openModal} className="bg-white px-4 py-3 rounded border-2 shadow-md shadow-red-600 hover:bg-gray-200">Open Modal</button> */}

        <Modal
          isOpen={false}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              {modalData?.item === "Section" ? "Delete Section" : "Delete Form"}
            </h2>

            <button onClick={closeModal} className="modal-close">
              {" "}
              <img src={closex} alt="copy" className="create-icon mb-0 me-2" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts">
              Are you sure you want to delete {modalData?.itemName}?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              {modalData.item === "Section" ? (
                <button
                  className="yes-btn rounded p-2"
                  onClick={() => {
                    deleteSection(modalData.itemId);
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>
              ) : (
                <button
                  className="yes-btn rounded p-2"
                  onClick={() => {
                    deleteForm(modalData.itemId);
                  }}
                >
                  {" "}
                  Yes{" "}
                </button>
              )}
              <p className="cancel-bttn" onClick={closeModal}>
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>
      <div className=" footer footer-bottom">
        <p className="p-0 m-0">&copy; Copyright ExtraHourz Inc. </p>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {(chatbotId === null || jobs.length === 0) &&
      loader === false &&
      !isEdit &&
      !isNew ? (
        <h4 className="mx-3 no-msg text-danger" style={{ fontSize: "40px" }}>
          <div class="d-flex justify-content-center bttns-div-center border-divs-edits">
            <div className="align-div-edits">
              <p className="center-div-top-text">No Jobs Found</p>

              {/* <button class="btn btn-default center-bttns" > <img src={upload} alt="test" className="upload-imags" />Create Job</button> */}
            </div>
          </div>
        </h4>
      ) : null}

      {loader && <Spinner />}
    </div>
  );
};

export default EditForms;
